import React, { useState } from "react";
import { Container, Row, Col, Card, Table, ProgressBar } from "react-bootstrap";
import "../style/dashboard.css";
import HelperFunction from '../util/helper'
import PreviewTransactionsPage from "./previewTransactions";
import DashboardSummary from "./dashboardSummery";
import DashboardSideNav from "./dashboardSidenav";
import DashboardHeader from "./dashboardHeader";
import Activity from "./activity";
import QuickActions from "./quickActions";
import Statistics from "./statistics";
import SavingsPlan from "./savingsPlan";
import CashFlow from "./dashboardCashflow";

const Dashboard = () => {
  const [user] = useState({
    name: "Andrew Forbisi",
    balance: 562000
  });

  const [stats] = useState({
    totalIncome: 78000,
    totalExpense: 43000,
    totalSavings: 56000,
    incomeChange: 17.8,
    expenseChange: -17.8,
    savingsChange: 21.4
  });

  const [dailyLimit] = useState({
    spent: 2500,
    limit: 20000,
    percentage: 12.5
  });

  const [savingPlans] = useState({
    total: 84500,
    plans: [
      { name: "Emergency Fund", current: 5000, target: 10000, percentage: 50 },
      { name: "Vacation Fund", current: 3000, target: 5000, percentage: 60 },
      { name: "Home Down Payment", current: 7250, target: 20000, percentage: 36.25 }
    ]
  });

  const [recentTransactions] = useState([
    {
      id: 1,
      name: "Electricity Bill",
      category: "Payments",
      date: "2024-03-01",
      time: "04:28:48",
      amount: -295.81,
      description: "Payment for monthly electricity",
      status: "Failed"
    },
    {
      id: 2,
      name: "Weekly Groceries",
      category: "Shopping",
      date: "2024-03-04",
      time: "04:28:48",
      amount: -204.07,
      description: "Groceries shopping at local supermarket",
      status: "Completed"
    },
    {
      id: 3,
      name: "Movie Night",
      category: "Entertainment",
      date: "2024-02-27",
      time: "04:28:48",
      amount: -97.84,
      description: "Tickets for movies and snacks",
      status: "Pending"
    },
    {
      id: 4,
      name: "Medical Check-up",
      category: "Healthcare",
      date: "2024-02-07",
      time: "04:28:48",
      amount: -323.33,
      description: "Routine health check-up and medications",
      status: "Pending"
    },
    {
      id: 5,
      name: "Dinner at Italian Restaurant",
      category: "Dining Out",
      date: "2024-02-11",
      time: "04:28:48",
      amount: -226.25,
      description: "Dining out with family at a local Italian restaurant",
      status: "Pending"
    }
  ]);

  const [expenseBreakdown] = useState([
    { category: "Rent & Living", amount: 2100, percentage: 40 },
    { category: "Investment", amount: 525, percentage: 15 },
    { category: "Education", amount: 420, percentage: 12 },
    { category: "Food & Drink", amount: 280, percentage: 8 },
    { category: "Entertainment", amount: 175, percentage: 5 }
  ]);

  const [recentActivity] = useState([
    {
      user: "Jamie Smith",
      action: "updated account settings",
      time: "10:05",
      avatar: "<i class='bi bi-person'></i>"
    },
    {
      user: "Alex Johnson",
      action: "logged in",
      time: "09:45",
      avatar: "👤"
    },
    {
      user: "Morgan Lee",
      action: "added a new savings goal for vacation",
      time: "09:05",
      avatar: "👤"
    },
    {
      user: "Taylor Green",
      action: "reviewed recent transactions",
      time: "21:05",
      avatar: "👤"
    },
    {
      user: "Wilson Baptiste",
      action: "transferred funds to emergency fund",
      time: "09:05",
      avatar: "👤"
    }
  ]);

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <DashboardSideNav />

      {/* Main Content */}
      <div className="main-content">
        {/* Header */}
        <DashboardHeader />

        <Container fluid>
          <Row>
            {/* Left Column */}
            <Col lg={9}>
              <DashboardSummary />

              {/* Cashflow Chart */}
              <Row className="mb-4">
                <Col md={4}>
                  {/* Quick Actions */}
                  <QuickActions />
                  

                  {/* Saving Plans Card */}
                  <SavingsPlan preview={true}/>
                </Col>
                <Col md={8}>
                  <CashFlow />

                  {/* Recent Transactions */}
                  <PreviewTransactionsPage />
                </Col>
              </Row>
            </Col>

            {/* Right Column */}
            <Col lg={3}>
              {/* Statistics Card */}
              <Statistics preview={true} />

              {/* Recent Activity Card */}
              <Activity preview={true}/>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Dashboard;